import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/TRECUPERA_newlogo.png'


const _hoisted_1 = { class: "modal-header w-full flex flex-shrink-0 border-b border-gray-200 rounded-t-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-md ml-2 text-black mt-1" }, "Cerrar", -1)
const _hoisted_3 = { class: "w-full text-left pt-5 mb-3 md:px-5 sm:px-3 grid grid-cols-2" }
const _hoisted_4 = { class: "text-lg font-bold" }
const _hoisted_5 = { class: "text-md" }
const _hoisted_6 = { class: "text-lg font-bold text-right" }
const _hoisted_7 = {
  class: "w-full flex flex-col text-left sm:pl-3 md:pl-9 md:pb-6 sm:pb-3 bg-gray-100",
  style: {"max-height":"64%"}
}
const _hoisted_8 = {
  key: 0,
  id: "messages",
  class: "flex flex-col space-y-4 p-3 overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch"
}
const _hoisted_9 = ["item"]
const _hoisted_10 = {
  key: 0,
  class: "flex items-start mb-5"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  alt: "logo",
  src: _imports_0,
  class: "rounded-xl w-8"
}, null, -1)
const _hoisted_12 = { class: "flex flex-col space-y-2 text-md max-w-xs mx-2 order-2 items-start" }
const _hoisted_13 = { class: "px-4 py-2 rounded-lg inline-block bg-white text-black" }
const _hoisted_14 = { class: "text-md text-black capitalize" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "chat-message my-1"
}
const _hoisted_17 = { class: "flex items-end justify-end" }
const _hoisted_18 = { class: "flex flex-col space-y-2 text-md max-w-xs mx-2 order-1 items-end" }
const _hoisted_19 = { class: "px-4 py-2 rounded-lg inline-block rounded-br-none bg-gray-300 text-black" }
const _hoisted_20 = { class: "text-md text-black capitalize" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "grid place-items-center mt-20 items-center"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block align-middle" }, "No hay registros disponibles", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "w-full grid my-2 py-2 text-md border-2" }
const _hoisted_26 = { class: "w-full grid grid-cols-1 sm:grid-cols-6 px-2 sm:text-left text-center text-md" }
const _hoisted_27 = { class: "sm:col-span-4" }
const _hoisted_28 = { class: "sm:col-span-2" }
const _hoisted_29 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_fa = _resolveComponent("fa")!
  const _component_sirit_right_menu = _resolveComponent("sirit-right-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_sirit_right_menu, { size: "md" }, {
      rightMenuContent: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeModal())),
            class: "cursor-pointer font-bold text-xl hover:text-sirit_blue-400"
          }, "x"),
          _hoisted_2
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_4, " Fra " + _toDisplayString($props.item.clientReference), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString($props.item.mainParticipant), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString($props.item.debitBalance
								? $setup.global.formatAmount($props.item.debitBalance)
								: ""), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.comments.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    item: item,
                    class: "chat-message"
                  }, [
                    (item.agentId !== null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(item.comment), 1)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createTextVNode(_toDisplayString($setup.global.getFormatDateComplete(
											item.creationDate,
											6
										)) + " ", 1),
                              (item.readDate !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                    _createVNode(_component_fa, {
                                      icon: "check",
                                      class: "cursor-pointer"
                                    }),
                                    _createTextVNode(" visto")
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(item.comment), 1)
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _createTextVNode(_toDisplayString($setup.global.getFormatDateComplete(
												item.creationDate,
												6
											)) + " ", 1),
                                (item.readDate !== null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                      _createVNode(_component_fa, {
                                        icon: "check",
                                        class: "cursor-pointer"
                                      }),
                                      _createTextVNode(" visto")
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                  ], 8, _hoisted_9))
                }), 128))
              ]))
            : (!_ctx.loading && _ctx.comments.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.submit()), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.msg.comment) = $event)),
                  placeholder: "Ingrese su mensaje",
                  name: "",
                  id: "",
                  cols: "30",
                  rows: "10",
                  class: "w-full h-14 py-5 px-2 mt-2 white rounded-l-xl border-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-sirit_blue-600"
                }, null, 512), [
                  [_vModelText, _ctx.msg.comment]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  disabled: _ctx.msg.comment === '',
                  type: "submit",
                  class: _normalizeClass([[
									_ctx.msg.comment === ''
										? 'bg-gray-400'
										: 'bg-sirit_blue-500 hover:bg-sirit_blue-600',
								], "w-10/12 h-14 text-white py-3 px-2 mt-2 m-2 rounded-r-md"])
                }, " Enviar ", 10, _hoisted_29)
              ])
            ])
          ], 32)
        ])
      ]),
      _: 1
    })
  ], 64))
}